import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivitySectionDirective, RestaurantTableService, UserActivityClickTrackingDirective } from '@core';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { SlideSocialComponent } from '@app/screens/more/slide-social/slide-social.component';
import { SlideAppComponent } from '@app/screens/more/slide-app/slide-app.component';
import { SlideWorkComponent } from '@app/screens/more/slide-work/slide-work.component';
import { SlideReviewComponent } from '@app/screens/more/slide-review/slide-review.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-screen-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
  imports: [
    TranslateModule,
    ActivitySectionDirective,
    UserActivityClickTrackingDirective,
    SwiperContainerComponent,
    SwiperSlideComponent,
    SlideSocialComponent,
    SlideAppComponent,
    SlideWorkComponent,
    SlideReviewComponent,
    PageHeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreComponent {

  public readonly back = output();

  public readonly bostonPizzaUI = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      return table?.integrations.find((integration) => {
        return integration.provider === 'bostonPizzaUI';
      })?.credentials;
    }),
  ));

  constructor(
    private readonly restaurantTable: RestaurantTableService,
  ) {}

}
